import {useEffect, useState} from "react";

/** Returns true after mount or key change to trigger width transitions from zero. */
export function useBarGrowth(restartKey: unknown): boolean {
    const [grown, setGrown] = useState(false);

    useEffect(() => {
        setGrown(false);

        let inner = 0;
        const outer = window.requestAnimationFrame(() => {
            inner = window.requestAnimationFrame(() => setGrown(true));
        });

        return () => {
            window.cancelAnimationFrame(outer);
            window.cancelAnimationFrame(inner);
        };
    }, [restartKey]);

    return grown;
}
